/* Reusable enums for signup flows. */
var FLEXIBLE_SECTIONS_TO_PROGRESS_STEPS_CONFIG = {
    dogs: {
        firstStepPath: '/profile/bab/pet/name/',
        percentagesByStep: { 1: 0, 2: 11, 3: 22 },
    },
    meals: {
        firstStepPath: '/profile/bab/pet/recipe/',
        percentagesByStep: { 1: 33, 2: 50 },
    },
    you: {
        firstStepPath: '/profile/bab/address/',
        percentagesByStep: { 1: 66 },
    },
    order: {
        firstStepPath: '/profile/bab/summary/',
        percentagesByStep: { 1: 100 },
    },
};
var FLEXIBLE_PERSONALIZED_SECTIONS = ['dogs', 'meals', 'you', 'order'];
var PERSONALIZED_SECTIONS_TO_PROGRESS_STEPS_CONFIG = {
    dogs: {
        firstStepPath: '/profile/pet/name/',
        percentagesByStep: { 1: 0, 2: 11, 3: 22 },
    },
    meals: {
        firstStepPath: '/profile/pet/recipe/',
        percentagesByStep: { 1: 33, 2: 50 },
    },
    you: {
        firstStepPath: '/profile/contact/',
        percentagesByStep: { 1: 66, 2: 82 },
    },
    order: {
        firstStepPath: '/profile/summary/',
        percentagesByStep: { 1: 100 },
    },
};
var OTTO_SECTIONS = ['you', 'address', 'order'];
var OTTO_SECTIONS_TO_PROGRESS_STEPS_CONFIG = {
    you: {
        firstStepPath: '/profile/otto/',
        percentagesByStep: { 1: 0 },
    },
    address: {
        firstStepPath: '/profile/otto/address/',
        percentagesByStep: { 1: 50 },
    },
    order: {
        firstStepPath: '/profile/otto/summary',
        percentagesByStep: { 1: 100 },
    },
};
export { FLEXIBLE_PERSONALIZED_SECTIONS, FLEXIBLE_SECTIONS_TO_PROGRESS_STEPS_CONFIG, OTTO_SECTIONS, OTTO_SECTIONS_TO_PROGRESS_STEPS_CONFIG, PERSONALIZED_SECTIONS_TO_PROGRESS_STEPS_CONFIG, };
